import axios from "axios";
import { LOAD_SHOWS, LOAD_SHOWS_WITH_VENUES, LOAD_SONGS, LOAD_ALBUMS, LOAD_VENUES } from "../actionTypes";
import { API_URL } from "../config";

export const getAlbums = () => {
  return async (dispatch) => {
		try {
	    const resp = await axios.get(API_URL + "/albums");
	    dispatch(gotAlbums(resp.data));
    } catch (e) {
      console.error(e)
    }
  };
};

export const getSongs = () => {
  return async (dispatch) => {
    try {
  	  const resp = await axios.get(API_URL + "/songs");
  	  dispatch(gotSongs(resp.data));
    } catch (e) {
      console.error(e)
    }
  };
};

export const getShows = () => {
  return async (dispatch) => {
    try {
	    const resp = await axios.get(API_URL + "/shows");
	    dispatch(gotShows(resp.data));
    } catch (e) {
      console.error(e)
    }
  };
};

export const getVenues = () => {
  return async (dispatch) => {
    try {
			const resp = await axios.get(`${API_URL}/venues`);
	    dispatch(gotVenues(resp.data));
    } catch (e) {
      console.error(e)
    }
  };
};

export const getShowsWithVenues = () => {
  return async (dispatch) => {
    try {
	    const resp = await axios.get(
	    	API_URL + "/shows?getVenueNames=true"
	    );
			console.log(resp.data)
	    dispatch(gotShowsWithVenues(resp.data.shows, resp.data.shows_prev));
    } catch (e) {
      console.error(e)
    }
  }
};

const gotAlbums = (albums) => {
	return {
		type: LOAD_ALBUMS,
		payload: {
			albums,
		},
	};
};

const gotSongs = (songs) => {
	return {
		type: LOAD_SONGS,
		payload: {
			songs,
		},
	};
};

const gotShows = (shows) => {
	const upcoming = shows.shows.map((s) => ({ ...s, is_previous_show: false }));
	const previous = (shows.shows_prev || []).map((s) => ({ ...s, is_previous_show: true }));
	return {
		type: LOAD_SHOWS,
		payload: {
			shows: [...upcoming, ...previous],
		},
	};
};

const gotVenues = (venues) => {
	return {
		type: LOAD_VENUES,
		payload: {
			venues,
		},
	};
};

const gotShowsWithVenues = (showsWithVenues, previousShowsWithVenues = []) => {
	const formatShows = (list, isPrevious) => list.map(s => {
		console.log({ ...s, date: s.date.substring(0, 10) });
		return {...s, date: s.date.substring(0, 10), is_previous_show: isPrevious}
	})
	const upcoming = formatShows(showsWithVenues, false);
	const previous = formatShows(previousShowsWithVenues, true);
	return {
		type: LOAD_SHOWS_WITH_VENUES,
		payload: {
			showsWithVenues: [...upcoming, ...previous],
		},
	};
};
